
<template>
  <div id="app">
    <v-app>
      <v-card class="overflow-hidden" height="100%">
        <v-app-bar class="v-app-bar " dense dark >
          <template v-slot:extension >
            <a :href=institute_info.URL target="_blank" >
              <img src="./assets/images/img.png" class="h30px mr-3 mt-2 logo_image" />
            </a>
            <router-link to="/" class="mx-3 white--text">
              <v-toolbar-title>{{ institute_info.Title }}</v-toolbar-title>
            </router-link>
            <v-tabs align-with-title class="d-none d-sm-block">
              <v-tab to="/form">فرم پرداخت الکترونیکی</v-tab>
              <v-tab to="/track">رهگیری پرداخت الکترونیکی</v-tab>
              <v-tab to="/report">گزارش وجوه</v-tab>

            </v-tabs>
            <div class="my-4">

            </div>

            <v-spacer></v-spacer>
            <v-toolbar-title class="admin_name">
           </v-toolbar-title>
            <div class="date">
              {{ institute_info.Date }}

            </div>
            <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
          </template>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" absolute temporary>
          <v-list nav dense>
            <v-list-item-group
                active-class="deep-red--text text--accent-4"
            >
              <v-list-item>
                <v-list-item-title>
                  <v-btn  to="/form" text width="100%">فرم پرداخت الکترونیکی</v-btn>
                </v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-list-item-title>
                  <v-btn to="/track" text width="100%">رهگیری پرداخت الکترونیکی</v-btn>
                </v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-list-item-title>
                  <v-btn to="/report" width="100%">گزارش وجوه</v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
        <v-content fluid>
          <v-container fluid>
            <router-view :key="$route.path"></router-view>
          </v-container>
        </v-content>
      </v-card>
      <v-footer :color="baseColor" class="white--text d-none d-sm-block pa-1">
<h5 class="mr-lg-12 mt-2 d-inline-block">
<a
  class="white--text"
  href="https://bp1.ir/products/binapay/"
  target="_blank"
>
  بیناپی | درگاه پرداخت سازمانی
</a>
محصولی از
<a class="white--text" href="https://bp1.ir/" target="_blank"
  >بینا پرداز یکتا</a
>
</h5>
</v-footer>
    </v-app>
  </div>
</template>

<script>
//import Home from './components/Home';
import { mapState } from "vuex";

//for using setting.js
// import {Title, URL} from "./setting";

//
export default {
  name: "app",
  components: {},
  props: {},
  data: () => ({
    drawer: false,
    //for using setting.js

    // URL:"",
    // today:"",
    // Title:"",
  }),
  methods: {},
  computed: {
    ...mapState({
      baseColor: (state) => state.baseColor,
      institute_info: (state) => state.institute_info,
    }),
  },
  mounted() {
    window.console.log("start function is called");
    this.$store.commit("pushQueue", {
      functionName: "Start",
      data: {},
    });
  },
  created: function () {
//    this.$store.commit("navigate", { url: "/" });
    window.console.log("In App.vue, window.history is:");
    window.console.log(window.history);
    //for using setting.js
    // this.Title=Title;
    // this.URL=URL;
    // this.today=new Date().toLocaleDateString('fa-IR');
  },
  watch: {
    "$route": {
      immediate: true,
      handler() {
        document.title="درگاه پرداخت "+this.institute_info.Title+' | بیناپی'
      }
    },
    institute_info:function (){
      document.title="درگاه پرداخت "+this.institute_info.Title+' | بیناپی'

    }
  }
}
</script>

<style>
@import "assets/css/material-icon.css";
@import "assets/css/style.css";

.router-link-exact-active {
  color: white;
}

.v-app-bar .v-toolbar__content{
  height: 0!important;

}
.v-app-bar{
  height: 48px!important;
}
.logo_image{
  background-image:none;
  color: white;
}
.date{
  font-size: 0.875rem!important;
  font-weight: 500!important;
}
</style>
